// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../../../i18n/l10n';
import { type Licence, Licences } from '../../../../types/common';
import { MPFamilies } from '../../constants/families';
import { MPCardStatuses, type MPCardStatus, type MPCardProps } from '../../types/cards';

import MPCard from './MPCard';

const HeaderWrapperTheme = {
  boxShadowColor: '#102f3f80',
  backgroundGradientTop: '#0e384d',
  backgroundGradientBottom: '#93f2ff',
};

const MPCardDetailsHeaderWrapper = styled.div`
  padding: 0.6em;
  position: relative;

  &::before {
    content: '';
    background: linear-gradient(
      to top,
      ${HeaderWrapperTheme.backgroundGradientTop},
      ${HeaderWrapperTheme.backgroundGradientBottom}
    );
    border-radius: 1em;
    bottom: 0;
    box-shadow: 0 0.125em 0.6em 0 ${HeaderWrapperTheme.boxShadowColor};
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
  }
`;

const MPCardDetailsHeaderContent = styled.div`
  background-image: linear-gradient(to bottom, #269dd9 0%, #0b2f41 100%);
  border-radius: 0.5em;
  padding: 1em;
  position: relative;
  z-index: 1;
`;

const MPCardDetailLabel = styled.div`
  -webkit-text-stroke: 1px #000;
  color: #fff;
  font-family: 'KabelHasbro';
  font-weight: 700;
  font-size: 1.8em;
  text-shadow: 0 1px 0 #000;
  text-transform: uppercase;
  transform: translateY(1px);
  text-align: center;
  margin-bottom: 0.6em;
`;

const StyledMPCard = styled(MPCard)`
  margin: 0 auto;
  height: 230px;
  width: 160px;
  margin-bottom: 1em;
`;

const DETAILS_LABEL = {
  // __('To be won')
  [MPCardStatuses.OPEN]: 'To be won',
  // __('In progress')
  [MPCardStatuses.PENDING]: 'In progress',
  // __('You win')
  [MPCardStatuses.WON]: 'You win',
};

type MPCardDetailsHeaderProps = {
  className?: string;
  status: MPCardStatus;
  card: MPCardProps;
  licence?: Licence;
};

const MPCardDetailsHeader = ({ className = '', status, card, licence = Licences.FR }: MPCardDetailsHeaderProps) => {
  return (
    <MPCardDetailsHeaderWrapper className={className}>
      <MPCardDetailsHeaderContent>
        <MPCardDetailLabel>{__(DETAILS_LABEL[status])}</MPCardDetailLabel>
        <StyledMPCard
          familyId={card.familyId}
          streetName={MPFamilies[card.familyId][card.index ?? 0].nameCard[licence]}
          status={status}
          cardType={MPFamilies[card.familyId][card.index ?? 0].type}
          isClickable={false}
        />
      </MPCardDetailsHeaderContent>
    </MPCardDetailsHeaderWrapper>
  );
};

export default MPCardDetailsHeader;
